import { SimpleStorage } from './storage.types';

/**
 * export is for testing purposes only
 * @internal
 */
export let _GLOBAL_STORE: Map<string, string>;

/**
 * Default in memory storage implementation. This is the fallback if other storage methods
 * are unavailable
 */
export class InMemoryStorage implements SimpleStorage {
  constructor() {
    _GLOBAL_STORE = new Map();
  }
  setItem(key: string, value: string): void {
    _GLOBAL_STORE.set(key, value);
  }
  getItem(key: string): string | null {
    return _GLOBAL_STORE.get(key) ?? null;
  }
  removeItem(key: string): void {
    _GLOBAL_STORE.delete(key);
  }
}

export const inMemoryStorage = new InMemoryStorage();
